import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class DelinquencyService {
  getAllDelinquencies(organizationId: string, propertyId: string) {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };

    return request(
      `${apiURL}/${organizationId}/${propertyId}/manage-delinquent-and-prepaid`,
      options,
    );
  }
}

export default DelinquencyService;
